@if (isCompletionDate) {
  <mat-form-field class="date-picker">
    <mat-label>{{ control.label }}</mat-label>
    <input
      matInput
      [formControl]="inputControl"
      [matDatepicker]="picker"
      [readonly]="control.readonly"
      [max]="today"
      [errorStateMatcher]="errorStateMatcher"
    />
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle
      matIconSuffix
      [for]="picker"
      [disabled]="control.readonly"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
} @else {
  <mat-form-field class="date-picker">
    <mat-label>{{ control.label }}</mat-label>
    <input
      matInput
      [formControl]="inputControl"
      [matDatepicker]="picker"
      [readonly]="control.readonly"
      [errorStateMatcher]="errorStateMatcher"
    />
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle
      matIconSuffix
      [for]="picker"
      [disabled]="control.readonly"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
}
